import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import glamorous from 'glamorous';
import { Card } from 'react-toolbox/lib/card';
import PasswordForm from '../../../../../common/components/PasswordForm';
import withQuery from '../../../../../common/components/withQuery';
import CurrentUserActions from '../../../../../redux-modules/current-user';
import CurrentCustomerActions from '../../../../../redux-modules/customers';
import OrganizationActions from "../../../actions/organizations";
import OnboardingNavigation from '../OnboardingNavigation';
import { StepHeader } from './index';
import ThemedInput from '../../../../../common/components/ThemedInput';
import Form from '../../../../../common/components/Form';
import LoadingOverlay from '../../../../../common/components/LoadingOverlay';
import callAPI from '../../../../../common/call-api';

const CardHeader = glamorous.div({
  marginBottom: 20,
  fontSize: '1.8rem',
});

const PasswordCard = glamorous(Card)({
  padding: '1.4rem 1.6rem',
  boxShadow: 'none !mportant',
});

class CreatePassword extends React.Component {
  static propTypes = {
    currentCustomer: PropTypes.shape({
      key: PropTypes.string,
      personaType: PropTypes.string,
    }),
    currentOrganization: PropTypes.shape({
      id: PropTypes.number,
    }),
    actions: PropTypes.shape({
      currentUser: PropTypes.object,
      organization: PropTypes.object,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
    }),
  };
  static contextTypes = {
    activateServiceDialogue: PropTypes.func,
  };

   state = {
    isLoading: false,
    errors: { form: [] },
  };


  handleSuccess = ({ resp }) => { 
    const { currentCustomer, actions } = this.props;
    if (currentCustomer) {
      // save relevant customer data (log in)
      Promise.all([
        actions.currentUser.setId(currentCustomer.key),
        actions.currentUser.updateAuth(resp.headers.get('authorizationtoken')),
        actions.currentUser.setType(currentCustomer.personaType),
      ]);
    }

    if (this.state.emailAfterPasscode) {
      if (this.state.orgKey) {
        actions.organization.get(this.state.orgKey).then(() => {
          this.props.goForward();
        });
      } else {
        this.props.goForward();
      }
    }
  };

  handleFailure = ({ resp }) => {
    if (resp && resp.status === 500) {
      return this.context.activateServiceDialogue();
    }
  };


     handleSubmit = ({ form, updateField }, onCompleteHandler) => {
      const { AccessCode } = form;
  
      const { eFedTokenKey } = this.props.location.query;
    
      this.setState(prevState => ({
        ...prevState,
        isLoading: true,
      }));
    
      const requestBody = {
        AccessCode: AccessCode,
        eFedTokenKey
      }
      callAPI("/api/cuss/credentials/accesscode", {
        method: 'POST',
        body: JSON.stringify(requestBody),
      })
        .then(
          results => {
            const { resp, json } = results;
            if (resp.ok && resp.status === 200) {
              const { actions } = this.props;
              actions.currentUser.setId(json.key),
              actions.currentUser.updateAuth(resp.headers.get('authorizationtoken')),
              actions.currentUser.setType(json.personaType);

              if (!json.credentials.isPasswordSet || json.credentials.isPasswordSet == false) {
                const { location, history } = this.props;
                const newQuery = { ...location.query, eFedTokenKey: null, email: json.credentials.username };
                if (history && history.replace) {
                  const searchParams = new URLSearchParams(newQuery);
                  history.replace({
                    ...location,
                    search: `?${searchParams.toString()}`
                  });
                }
                this.setState({ isLoading: false, emailAfterPasscode : json.credentials.username, orgKey: json.organization ? json.organization.key : null });
                return;
              }
    
              if (json.organization && json.organization.key) {
                actions.organization.get(json.organization.key).then(() => {
                  this.setState(prevState => ({
                    ...prevState,
                    isLoading: false,
                  }));
                  this.props.goForward();
                });
              }
            } else {
              this.setState(prevState => ({
                ...prevState,
                isLoading: false,
                errors: {
                  ...prevState.errors,
                  form: [json.message],
                },
              }));
            }
          }
        )
        .catch(() => {
          this.setState(prevState => ({
            ...prevState,
            isLoading: false,
          }));
        });
    };

  render() {
    const { currentCustomer, currentOrganization, location:  {query} } = this.props;
    const { credentials = {} } = currentCustomer || {};
    
     var formInputs = [
        {
          Component: ThemedInput,
          name: 'AccessCode',
          label: 'Access Code',
          type: 'text',
          required: true,
        }
      ];

     if(query && query.eFedTokenKey && !this.state.emailAfterPasscode){
      
      return <div>
        <h1>Login</h1>
        <Form
          initState={{}}
          formInputs={formInputs}
          formSubmit={this.handleSubmit}
          formErrors={this.state.errors.form}
        />
        <LoadingOverlay isLoading={this.state.isLoading} />
      </div>
    }

    if (!currentCustomer || !currentOrganization || credentials.isPasswordSet) {
      return (
        <Card
          style={{ padding: '40px 0px', textAlign: 'center', fontSize: '3rem', boxShadow: 'none' }}
        >
          Loading...
        </Card>
      );
    }

    return (
      <div>
      <StepHeader>Thank you for being an NFIB member.</StepHeader>
      <PasswordForm
        username={this.state.emailAfterPasscode || this.props.location.query.email}
        passwordEndpoint="/api/cuss/credentials/initializePassword"
        onSuccess={this.handleSuccess}
        onFailure={this.handleFailure}
        FormWrapper={PasswordCard}
        renderSubmit={() => (
        <OnboardingNavigation
          {...this.props}
          goForward={null}
          submitOnNext
        />
        )}
      >
        <CardHeader>
        To get started with NFIB.com, please setup a password and answer a
        few quick questions.
        </CardHeader>
      </PasswordForm>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      currentUser: bindActionCreators(CurrentUserActions, dispatch),
      currentCustomer: bindActionCreators(CurrentCustomerActions, dispatch),
      organization: bindActionCreators(OrganizationActions, dispatch)
    },
  };
};

export default withQuery(connect(null, mapDispatchToProps)(CreatePassword));



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/CreatePassword.js